import camelcaseKeys from 'camelcase-keys'
import { isNotNil } from 'ramda'

export enum DomainType {
  RAW = 'raw',
  API = 'api',
  SSE = 'sse',
  CDN = 'cdn',
  IMAGES = 'images',
  STORAGE = 'storage',
}

export const camelizeKeys = (object: Record<string, any>): any => {
  return camelcaseKeys(object, { deep: true })
}

const toSnakeCase = (str: string) => {
  return str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`)
}

// snake_case keys 的遞歸方法
export const snakelizeKeys = (obj: any): any => {
  if (Array.isArray(obj)) {
    return obj.map(v => snakelizeKeys(v)) // 递归处理数组
  } else if (isNotNil(obj) && obj.constructor === Object) {
    return Object.keys(obj).reduce((result: any, key: string) => {
      const snakeKey = toSnakeCase(key)
      result[snakeKey] = snakelizeKeys(obj[key]) // 递归处理对象
      return result
    }, {})
  }
  return obj
}

export const removeEmpty = (obj: any) => {
  const result = Object.keys(obj)
    .filter(k => obj[k] != null)
    .reduce((a, k) => ({ ...a, [k]: obj[k] }), {})
  return result
}

export const censorText = ({
  text,
  bannedWords,
}: {
  text: string
  bannedWords: string[]
}) => {
  let censoredText = text
  bannedWords?.forEach(bannedWord => {
    const regex = new RegExp(bannedWord, 'g')
    const stars = '*'.repeat(bannedWord.length)
    censoredText = censoredText.replace(regex, stars)
  })
  return censoredText
}

export const convertDuration = (num: number | undefined) => {
  if (num === undefined) {
    return '00:00'
  }

  let mins = 0
  mins = Math.floor(num / 60)

  if (isNaN(mins) || num === 0) {
    return '00:00'
  }

  if (mins >= 60) {
    const hours = Math.floor(mins / 60)
    mins = mins % 60
    const secs = mins % 60
    const minsString = mins >= 10 ? mins : '0' + mins
    const secsString = secs >= 10 ? secs : '0' + secs
    const result = `${hours}:${minsString}:${secsString}`
    return result
  }

  const secs = num % 60

  const minsString = mins >= 10 ? mins : '0' + mins
  const secsString = secs >= 10 ? secs : '0' + secs
  const result = `${minsString}:${secsString}`
  return result
}

type GetSpecialPriceProps = {
  price: number | undefined
  discount: number | undefined
  inverse?: boolean
}

export const getSpecialPrice = (payload: GetSpecialPriceProps) => {
  const { price, discount = 0, inverse = false } = payload

  console.log('🚀 ~ getSpecialPrice ~ price:', { price, discount })
  if (!price) {
    return 0
  }
  const calculatedDiscount = inverse ? 100 - discount : discount
  const actualDiscount = calculatedDiscount === 0 ? 100 : calculatedDiscount

  return price * (actualDiscount / 100)
}

export const getPrice = (price: number) => {
  if (price === undefined) {
    return 0
  }

  return price / 100
}

export const getDaysFrom = ({
  t,
  quantity,
  unit,
}: {
  t: any
  quantity: number
  unit: string
}) => {
  if (unit === 'month') {
    const days = quantity * 30
    return `${days} ${t('common.unit.day')}`
  }

  return `${quantity}${unit}`
}

export function getDynamicDomainBy({
  type,
  isDynamicDomain = false,
  isDevelopment = false,
}: {
  type: DomainType
  isDynamicDomain?: boolean
  isDevelopment?: boolean
}) {
  // 檢查是否在瀏覽器環境
  const isBrowser = typeof window !== 'undefined'
  // console.log('🚀 ~ isBrowser:', { isBrowser, isDynamicDomain })

  // 獲取協議和域名
  const protocol = isBrowser ? window.location.protocol : 'https:'
  const hostname = isBrowser ? window.location.hostname : 'mfans.live'
  const mainDomain = hostname.match(/[^.]+\.[^.]+$/)?.[0]
  const isLocal = isBrowser
    ? window.location.origin.includes('localhost')
    : false
  const domain = isLocal ? 'qjyhqjdp.com' : mainDomain

  switch (type) {
    case DomainType.RAW:
      return isDynamicDomain ? `${domain}` : `mfans.live`
    case DomainType.API:
      return isDynamicDomain
        ? `${protocol}//${process.env.NEXT_PUBLIC_API_SUB_DOMAIN}.${domain}/api`
        : `${process.env.NEXT_PUBLIC_API_URL}`
    case DomainType.SSE:
      return isDynamicDomain
        ? `${protocol}//${process.env.NEXT_PUBLIC_SSE_SUB_DOMAIN}.${domain}/api`
        : `${process.env.NEXT_PUBLIC_SSE_URL}`
    case DomainType.IMAGES:
      return isDynamicDomain && !isDevelopment
        ? `${protocol}//${process.env.NEXT_PUBLIC_IMAGES_SUB_DOMAIN}.${domain}/web`
        : `${protocol}//${process.env.NEXT_PUBLIC_IMAGES_SUB_DOMAIN}.mfans.live/web`

    case DomainType.STORAGE:
      // return isDynamicDomain
      //   ? `${protocol}//${process.env.NEXT_PUBLIC_STORAGE_SUB_DOMAIN}.${domain}`
      //   : `${process.env.NEXT_PUBLIC_STORAGE_HOST}`
      return `${protocol}//${process.env.NEXT_PUBLIC_IMAGES_SUB_DOMAIN}.mfans.live`
  }
}

export const getIdsBySexualCategory = (
  sexualCategoryIds: number[],
  params: { BG: number[]; BB: number[] },
) => {
  const BG = sexualCategoryIds.some((id: number) => [1, 3, 6].includes(id))
    ? params.BG
    : []
  const BB = sexualCategoryIds.includes(2) ? params.BB : []
  return [...BG, ...BB]
}
